import React from 'react'

import { Col, Form } from '_zari/core'

const ImporteDescuentoFormGroup = ({ iValue }) => {
  return (
    <Form.Group>
      <Form.Label text='DESCUENTO' htmlFor='input-importeDescuento' md={6} alignRightAt='md' />
      <Col md={6}>
        <Form.InputNumber id='input-importeDescuento' name='input-importeDescuento' value={iValue} disabled />
      </Col>
    </Form.Group>
  )
}

export default React.memo(ImporteDescuentoFormGroup)
